
import { useState } from 'react';
import LanguageToggle from '../base/LanguageToggle';

interface HeaderProps {
  language: 'es' | 'en';
  onLanguageChange: (lang: 'es' | 'en') => void;
}

export default function Header({ language, onLanguageChange }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const content = {
    es: {
      services: 'Servicios',
      about: 'Sobre Nosotros',
      testimonials: 'Testimonios',
      faq: 'FAQ',
      contact: 'Contacto'
    },
    en: {
      services: 'Services',
      about: 'About Us',
      testimonials: 'Testimonials',
      faq: 'FAQ',
      contact: 'Contact'
    }
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-red-600/95 backdrop-blur-sm shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
              <span className="text-red-600 text-xl">🐾</span>
            </div>
            <div>
              <h1 className="text-white font-bold text-lg" style={{ fontFamily: 'Pacifico, serif' }}>
                First Step Japan
              </h1>
              <p className="text-white/80 text-xs">Your new beginning 🇯🇵</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-gold-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              {content[language].services}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-gold-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              {content[language].about}
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-white hover:text-gold-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              {content[language].testimonials}
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-white hover:text-gold-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              {content[language].faq}
            </button>
            <LanguageToggle currentLang={language} onLanguageChange={onLanguageChange} />
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-4">
            <LanguageToggle currentLang={language} onLanguageChange={onLanguageChange} />
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-gold-400 transition-colors cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-red-700/95 backdrop-blur-sm rounded-lg mt-2 p-4 space-y-3">
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-white hover:text-gold-400 transition-colors cursor-pointer py-2"
            >
              {content[language].services}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-white hover:text-gold-400 transition-colors cursor-pointer py-2"
            >
              {content[language].about}
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-white hover:text-gold-400 transition-colors cursor-pointer py-2"
            >
              {content[language].testimonials}
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-white hover:text-gold-400 transition-colors cursor-pointer py-2"
            >
              {content[language].faq}
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
